// Import the global style variables as an internal bridge for Web App to consume the variables from .ts/.tsx
import variables from '@skytvnz/sky-app-style/lib/skyGo/variables.json';

export default variables;
